import { LayoutDashboard, ShieldAlert, Wallet, BarChart3, Network, ScrollText, Boxes, Plug, FileCheck2, Users, LifeBuoy, Cpu, Home, AppWindow, Wand2, Compass, Activity, BookText, Inbox, GraduationCap } from "lucide-react";

export const ADMIN_NAV = [
  { path: "/admin/cockpit", label: "Cockpit", icon: LayoutDashboard, module: "Lens" },
  { path: "/admin/risk", label: "Risk", icon: ShieldAlert, module: "Guard" },
  { path: "/admin/ledger", label: "Cost Ledger", icon: Wallet, module: "Ledger" },
  { path: "/admin/usage", label: "Usage & Value", icon: BarChart3, module: "Lens" },
  { path: "/admin/gateway", label: "Gateway", icon: Network, module: "Gate" },
  { path: "/admin/policies", label: "Policies", icon: ScrollText, module: "Guard" },
  { path: "/admin/apps", label: "AI Apps Inventory", icon: Boxes, module: "Guard" },
  { path: "/admin/hub", label: "Integration Hub", icon: Plug, module: "Hub" },
  { path: "/admin/evidence", label: "Evidence", icon: FileCheck2, module: "Lens" },
  { path: "/admin/access", label: "Access (RBAC)", icon: Users, module: "Core" },
  { path: "/admin/help", label: "Help & Guides", icon: LifeBuoy, module: "Hub" },
];

export const COMPANION_NAV = [
  { path: "/companion/home", label: "Home", icon: Home },
  { path: "/companion/tools", label: "My AI Tools", icon: AppWindow },
  { path: "/companion/prompt-studio", label: "Prompt Studio", icon: Wand2 },
  { path: "/companion/advisor", label: "Model & Tool Advisor", icon: Compass },
  { path: "/companion/activity", label: "My Activity", icon: Activity },
  { path: "/companion/policy", label: "Policy in Plain Words", icon: BookText },
  { path: "/companion/requests", label: "Requests", icon: Inbox },
  { path: "/companion/learn", label: "Learn", icon: GraduationCap },
];
